import {
    apiFundList,
    apiFundDetail,
    apiFundDetailByName,
    apiFundTrendings,
    apiFundTopHoldings,
    apiFundPerformance,
    apiFundBreakdown,
    apiFundNavVerify,
    apiFundDividend,
    apiFund3D,
    apiFundFee,
    apiFundNav,
    apiFundNavLatest,
    apiFundFilter,
    apiFundCategories,
    apiFundAmc,
    apiFundCard,
    apiFundInvestNow
} from "../../api/fund.js";
import * as constant from './constant'
export const actions = {
    async findFundList({ commit }) {
        const rs = await apiFundList();
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                await commit(constant.FUND_LIST, data)
            }
        }
    },

    async findFundAmc({ commit }) {
        const rs = await apiFundAmc();
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                await commit(constant.FUND_AMC, data)
            }
        }
    },

    async findFundCategories({ commit }) {
        const rs = await apiFundCategories();
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                let arr = []
                data.map(({
                    id,
                    name,
                    sub_categories
                }) => {
                    let obj = {
                        title: name,
                        value: id,
                        children: sub_categories.map(({
                            id,
                            name
                        }) => {
                            let sub_objs = {
                                title: name,
                                value: id,
                            }
                            return sub_objs
                        })
                    }
                    arr = [...arr, obj]
                })
                await commit(constant.FUND_CATEGORIES, arr)
            }
        }
    },

    async findFundDetail({ commit }, fund_id) {
        const rs = await apiFundDetail(fund_id);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                return data
            }
        }
    },

    async findFundDetailByName({ commit }, fund_name) {
        const rs = await apiFundDetailByName(fund_name);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                return data
            }
        }
    },

    async findFund3D({ commit }, fund_id) {
        const rs = await apiFund3D(fund_id);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                return data
            }
        }
    },

    async findFundPerformance({ commit }, fund_id) {
        const rs = await apiFundPerformance(fund_id);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                return data
            }
        }
    },

    async findFundBreakdown({ commit }, fund_id) {
        const rs = await apiFundBreakdown(fund_id);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                return data
            }
        }
    },

    async findFundTopHoldings({ commit }, fund_id) {
        const rs = await apiFundTopHoldings(fund_id);
        if (rs && rs.status == 200 && rs.data.top_holdings && rs.data.top_holdings.length > 0) {

            let data = rs.data.top_holdings[0]
            if (data) {
                var datas = []
                for (var i = 0; i <= (data.assets.length - 1); i++) {
                    datas.push(data.assets[i].percent)
                }
                let sumValue = datas.reduce((a, b) => a + b, 0)
                if (sumValue < 100) {
                    let otherVal = 100 - sumValue
                    let otherValToFixed = otherVal.toFixed(2)
                    if (datas && datas.length > 0) {
                        data.assets.push({
                            name: 'อื่นๆ',
                            percent: otherValToFixed,
                            short_code: 'OTHER'
                        })
                    }

                }
                return data
            }
        }
    },

    async findFundNavLatest({ commit }, fund_id) {
        const rs = await apiFundNavLatest(fund_id);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                return data
            }
        }
    },

    async findFundDividend({ commit }, fund_id) {
        const rs = await apiFundDividend(fund_id);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                return data
            }
        }
    },

    async findFundNav({ commit }, { fund_id, period }) {
        const rs = await apiFundNav(fund_id, period);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                if(period === "1D") {
                    data = data.slice(data.length-2, data.length)
                }
                await commit(constant.FUND_NAV, data)
            }
        }
    },

    async findFundNavForShare({ commit }, { fund_id, period }) {
        const rs = await apiFundNav(fund_id, period);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                return data
            }
        }
    },

    async findFundNavVerify({ commit }, fund_id) {
        const rs = await apiFundNavVerify(fund_id);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                await commit(constant.FUND_NAV_VERIFY, data)
            }
        }
    },

    async findFundTrendingList({ commit }) {
        const rs = await apiFundTrendings();
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                await commit(constant.FUND_TRENDING_LIST, data.data)
            }
        }
    },

    async findFundFee({ commit }, fund_id) {
        const rs = await apiFundFee(fund_id);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                return data
            }
        }
    },

    async saveFundPeriod({ commit }, period) {
        await commit(constant.FUND_PERIOD, period)
    },

    async saveFundUnitType({ commit }, type) {
        await commit(constant.FUND_UNIT_TYPE, type)
    },

    async findFundFilter({ commit }, payload) {
        const rs = await apiFundFilter(payload);
        if (rs && rs.status == 200) {
            let { data } = rs
            if (data) {
                await commit(constant.FUND_RANKING, { payload: data.data, period: data.period, pagination: data.pagination })
            }
        }
    },

    async findFundFollowing({ commit }) {
        let mockData = [
            {
                id: "F000000RKP",
                name: "BTP",
                data_date: "2019-01-01",
                price: 109,
                period: "1D",
                percent: -2.0
            },
            {
                id: "F000000RF1",
                name: "K-CASH",
                data_date: "2019-01-01",
                price: 109,
                period: "1D",
                percent: 1.22
            }
        ]
        await commit(constant.FUND_FOLLOWING, mockData)

    },

    async updateFundFollowing({ commit }, payload) {
        await commit(constant.FUND_FOLLOWING, payload)
    },

    async sendFundCard({ commit }, payload) {
        try {
            const rs = await apiFundCard(payload);
            if (rs && rs.status == 200) {
                let data = rs.data
                if (data) {
                    return data
                }
            }
        } catch (error) {
            throw new Error(error)
        }
    },

    async sendFundInvestImage({ commit }, payload) {
        await apiFundInvestNow(payload);
    },
}